import { DropdownMenu, useDropdownDirection } from '@consigli/facade';
import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { TopicDropdownContent } from './topic-dropdown-content';
import { TopicDropdownFooter } from './topic-dropdown-footer';

interface BulkAddTopicPopoverProps {
  isOpen: boolean;
  availableTopics: string[];
  onSelect: (topicId: string) => void;
  onAddCustomTopic?: (topic: string) => void;
}

/**
 * Bulk topic popover that reuses TopicDropdownContent + TopicDropdownFooter for
 * consistency. Renders the same topic dropdown as EditableTopic but in a bulk context.
 */
export const BulkAddTopicPopover: FC<BulkAddTopicPopoverProps> = ({
  isOpen,
  availableTopics,
  onSelect,
  onAddCustomTopic,
}) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);

  const openDirection = useDropdownDirection({
    containerRef,
    isOpen,
    dropdownHeight: 350,
  });

  return (
    <div className="relative" ref={containerRef}>
      <DropdownMenu
        isOpen={isOpen}
        direction={openDirection}
        header={t('meeting-secretary.action-items.select-topic', 'Select Topic')}
        width="w-56"
        scrollable
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
        onKeyDown={(e: React.KeyboardEvent) => e.stopPropagation()}
        footer={
          <TopicDropdownFooter
            isOpen={isOpen}
            onAddCustomTopic={(topic) => {
              onSelect(topic);
              onAddCustomTopic?.(topic);
            }}
          />
        }
      >
        <TopicDropdownContent
          topics={availableTopics}
          showClearOption
          onSelect={onSelect}
          onClear={() => onSelect('')}
        />
      </DropdownMenu>
    </div>
  );
};
